/**
 * Trigger Candid header dropdown for the Candid Upload table.
 */
import { ButtonWithDropdown } from "risa-oasis-ui_v2";
import { CandidUploadDropdownAction } from "./candidUploadActions";

interface CandidUploadTriggerMenuProps {
  /** Invoked with a {@link CandidUploadDropdownAction} id when a menu item is chosen. */
  onAction: (action: string) => void;
}

/**
 * Renders the "Trigger Candid" secondary button with Document Upload,
 * Authorization Information, and Patient Auth Notes actions.
 *
 * @param props.onAction - Click handler for each dropdown menu item
 * @returns The dropdown button element
 */
const CandidUploadTriggerMenu = ({
  onAction,
}: CandidUploadTriggerMenuProps) => {
  return (
    <ButtonWithDropdown
      alwaysOpenDropdown
      buttonType="secondary"
      menuData={[
        {
          id: CandidUploadDropdownAction.DocumentUpload,
          label: "Document Upload",
          onClick: () => onAction(CandidUploadDropdownAction.DocumentUpload),
        },
        {
          id: CandidUploadDropdownAction.AuthorizationInformation,
          label: "Authorization Information",
          onClick: () =>
            onAction(CandidUploadDropdownAction.AuthorizationInformation),
        },
        {
          id: CandidUploadDropdownAction.AuthNotes,
          label: "Patient Auth Notes",
          onClick: () => onAction(CandidUploadDropdownAction.AuthNotes),
        },
      ]}
      onButtonClick={() => undefined}
      onClick={() => undefined}
      size="medium"
      disabled={false}
    >
      Trigger Candid
    </ButtonWithDropdown>
  );
};

export default CandidUploadTriggerMenu;
